import { useQuery } from '@tanstack/react-query';

import { getAuth } from '@services/identity.service';
import { getMyFeatureFlags } from '@services/feature-flags.service';

export const FEATURES = Object.freeze({
  LLM_CONNECTOR: 'llm-connector',
  ZOOM_EVENTS: 'zoom-events',
  EXTENSION_READER_TARGETING: 'extension-reader-targeting',
});

export type FeatureKey = typeof FEATURES[keyof typeof FEATURES];

const STALE_MS = 60 * 1000;

export const useFeatureFlags = () => {
  const userId: string | undefined = getAuth()?.id;

  const { data, isPending } = useQuery({
    queryKey: ['feature-flags', userId],
    queryFn: getMyFeatureFlags,
    enabled: !!userId,
    staleTime: STALE_MS,
    retry: false,
  });

  const enabled = data?.status === true ? (data.entity?.features || []) : [];

  return {
    isEnabled: (key?: FeatureKey) => !key || enabled.includes(key),
    isResolved: !!userId && !isPending,
  };
};

export const useFeatureFlag = (key: FeatureKey) => {
  const { isEnabled, isResolved } = useFeatureFlags();
  return { isEnabled: isEnabled(key), isResolved };
};
